import { useApp, numberFormat, SplitText } from '@libs/core';
import { TAssetsSvgMapValue, TFeeOption } from '@libs/types';
import React from 'react';
import { ButtonCircleView } from '../../Buttons/ButtonCircleView';
import { ButtonRowView } from '../../Buttons/ButtonRowView';
import { PopupComponent } from '../../UI/Popup/PopupComponent';
import PricingTab from '../pricing-tab/PricingTab';
import { FeeBlock } from './FeeBlock';

type TFeePanelProps = {
    sum?: string;
    currency?: string;
    iconName?: TAssetsSvgMapValue;
    label: string;
    text: string;
    feeBottomSheetFirstText?: string;
    feeBottomSheetSecondText?: string;
    feeOptions?: TFeeOption[];
    bottomSheetButton: string;
};

const Fee = React.memo(
    ({ sum, iconName, label, text, feeBottomSheetFirstText, feeBottomSheetSecondText, feeOptions, bottomSheetButton, currency = '' }: TFeePanelProps) => {
        const { setPopup } = useApp();
        const handleClick = () => {
            setPopup(
                <PopupComponent
                    header={
                        <>
                            <p>
                                <SplitText text={feeBottomSheetFirstText ?? ''} />
                            </p>
                            {feeOptions?.map((option, index, array) => {
                                const marginBottom = index === array.length - 1 ? 32 : 16;
                                const marginTop = index === 0 ? 32 : undefined;
                                return (
                                    <PricingTab
                                        key={index + option.optionName}
                                        text={option?.optionName}
                                        fee={`${option?.optionFee?.value ?? ''} ${option?.optionFee?.currency ?? ''} ${option?.optionFee?.label}`}
                                        marginTop={marginTop}
                                        marginBottom={marginBottom}
                                    />
                                );
                            })}
                            <p>
                                <SplitText text={feeBottomSheetSecondText ?? ''} />
                            </p>
                        </>
                    }
                    externalContent={[<ButtonRowView key="button_ic_check" label={bottomSheetButton} iconName={'ic_check'} onClick={() => setPopup(null)} />]}
                />,
            );
        };
        return (
            <FeeBlock
                icon={
                    iconName ? (
                        <ButtonCircleView
                            hierarchy={'tertiary'}
                            size={'small'}
                            iconName={iconName}
                            iconWidth={16}
                            iconHeight={16}
                            iconColor="var(--color-grey_72_lc)"
                            onClick={handleClick}
                            margin={{ top: -5 }}
                        />
                    ) : null
                }
                title={label ?? ''}
                text={'' + text}
                rate={`${numberFormat(sum)} ${currency}`}
            />
        );
    },
);
export { Fee };
